import { JwtTokens } from '@wizbii/angular-utilities';
import { IdentityCard, UserOverview } from '@wizbii/models';

export class Init {
  static readonly type = '[Session] Init';
  constructor(public tokens?: JwtTokens) {}
}

export class GetUserInfo {
  static readonly type = '[Session] GetUserInfo';
  constructor(public userId: string) {}
}

export class UpdateIdentityCard {
  static readonly type = '[Session] UpdateIdentityCard';
  constructor(public identityCard: Partial<IdentityCard>) {}
}

export class SetUser {
  static readonly type = '[Session] Set User';
  constructor(public user: UserOverview) {}
}

export class Logout {
  static readonly type = '[Session] Logout';
}
